import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Close from '@mui/icons-material/Close';

import { Chip } from 'uikit/chips';
import { Button } from 'uikit/buttons';

import styles from '../styles/uikitInputsChips.module.scss';

const TextChipsInput = ({
  id,
  className = '',
  placeholder = '',
  value = '',
  onChange = null,
  onKeyUp = () => {},
  ref = null,
  inputRef = null,
  isDisabled = false,
  onKeyDown = null,
  testId = '',
  inputTestId = '',
  chips = [],
  autoComplete = 'off',
  name = '',
  ariaLabel = '',
  hasClearButton = false,
  onClearButtonClick = () => {},
}) => (
  <div
    className={classnames(
      styles.element,
      {
        [styles.hasChips]: !!chips.length,
      },
      className,
    )}
    data-testid={testId}
    ref={ref}
  >
    {chips.map((chip) => (
      <Chip
        className={styles.chip}
        key={chip.key}
        text={chip.text}
        onClick={() => chip.onClick(chip)}
      />
    ))}
    <input
      id={id}
      className={classnames(styles.input, className)}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      ref={inputRef}
      value={value}
      disabled={isDisabled}
      data-testid={inputTestId}
      autoComplete={autoComplete}
      name={name}
      aria-label={ariaLabel}
    />
    {hasClearButton && (
      <Button
        variant="ghost"
        icon={<Close />}
        size="xsmall"
        onClick={onClearButtonClick}
        className={classnames(styles.button, className)}
      />
    )}
  </div>
);

TextChipsInput.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isDisabled: PropTypes.bool,
  onKeyDown: PropTypes.func,
  testId: PropTypes.string,
  inputTestId: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  chips: PropTypes.array,
  autoComplete: PropTypes.oneOf(['on', 'off']),
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  hasClearButton: PropTypes.bool,
  onClearButtonClick: PropTypes.func,
};

export default React.memo(TextChipsInput);
